export default __webpack_public_path__ + "static/bunker-desktop-cbb3810fb400a5629a018f410cc43307.mp4";